import { environment } from 'src/environments/environment';

/**
 * True when the app is configured for iframe embedding and actually runs inside a parent frame.
 * Matches the condition used by `IframeHeightReporterService` for height postMessage.
 */
export function isEmbeddedFromParentOrigin(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return Boolean(environment.iframeParentOrigin) && window.parent !== window;
}
